import { seededRandom } from '../core/board';
import { packsForLocale, type WordPack } from './packs';

export type ThemeHistory = Partial<Record<'en' | 'es', string[]>>;
const themes = ['forest', 'ocean', 'cosmos', 'garden', 'kitchen'];
export function rememberTheme(history: ThemeHistory, locale: string, packId: string): ThemeHistory {
  if (locale !== 'en' && locale !== 'es') return history;
  const theme = packId.replace(/-es$/, '');
  if (!themes.includes(theme)) return history;
  return { ...history, [locale]: [...(history[locale] ?? []).filter(item => item !== theme), theme].slice(-5) };
}
export function recoverThemes(...sources: unknown[]): ThemeHistory {
  let history: ThemeHistory = {};
  for (const source of sources) {
    if (!source || typeof source !== 'object' || Array.isArray(source)) continue;
    for (const locale of ['en', 'es'] as const) {
      const values = (source as ThemeHistory)[locale];
      if (Array.isArray(values)) for (const theme of values.slice(-5)) if (typeof theme === 'string') history = rememberTheme(history, locale, theme);
    }
  }
  return history;
}
export function rotatingTheme(locale: string, history: ThemeHistory, seed: string): WordPack {
  const recent = history[locale as 'en' | 'es'] ?? [];
  const candidates = packsForLocale(locale).filter(pack => themes.includes(pack.id.replace(/-es$/, ''))
    && !recent.slice(-2).includes(pack.id.replace(/-es$/, '')));
  const random = seededRandom(`${seed}:${locale}:${recent.join(',')}`);
  return candidates[Math.floor(random() * candidates.length)]!;
}
